var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:_vm.id,attrs:{"wordNumber":_vm.wordNumber}}),(_vm.isCount)?_c('div',{staticClass:"editor-word-number"},[_c('span',[_vm._v("字数统计：")]),_c('span',[_vm._v(_vm._s(_vm.count)+" / "+_vm._s(_vm.wordNumber))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }